import React, { Component } from 'react';

class Result extends Component {
    state = {
        name: "Mario",
        winner: true
    }   



  render() { // tout ceci peut aussi s'écrire this.state.winner ? () : ();    si c'est vrai, alors fait la première parenthese, sinon, fais la deuxième
    if (this.state.winner === true ) {
        return(
      <div>
        <h1>bravo {this.state.name}</h1>
      </div>
      )
    }else{
        return(
            <div>
              <h1>raté!!!</h1>
            </div>
            )  
    }
  }
}

export default Result